import { ClipboardCheck, FileText, Users, BarChart3 } from "lucide-react";
import { Reveal } from "@/components/Reveal";

const STEPS = [
  {
    icon: ClipboardCheck,
    num: "01",
    title: "Sopralluogo gratuito",
    text: "In presenza o in videochiamata, entro 24 ore dalla richiesta. Ascoltiamo le esigenze e misuriamo gli spazi.",
  },
  {
    icon: FileText,
    num: "02",
    title: "Capitolato trasparente",
    text: "Un preventivo dettagliato voce per voce: cosa facciamo, quando, con quali prodotti e a quale prezzo.",
  },
  {
    icon: Users,
    num: "03",
    title: "Team dedicato",
    text: "Squadre formate e referenti unici, con schede prodotto e detergenti ecologici certificati.",
  },
  {
    icon: BarChart3,
    num: "04",
    title: "Controllo qualità",
    text: "Verifiche periodiche e reportistica digitale: ogni intervento è tracciato e misurabile.",
  },
];

const MethodSection = () => (
  <section id="metodo" className="bg-[#0F172A] py-20 lg:py-28">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <Reveal>
        <span className="text-xs font-bold uppercase tracking-[0.2em] text-[#00B36B]">
          Il metodo Clario
        </span>
        <h2 className="mt-3 max-w-2xl text-2xl font-bold tracking-tight text-white sm:text-3xl lg:text-4xl">
          Quattro passi,{" "}
          <span className="font-serif-accent font-medium text-[#00B36B]">zero sorprese</span>
        </h2>
      </Reveal>

      <div className="mt-14 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
        {STEPS.map(({ icon: Icon, num, title, text }, i) => (
          <Reveal key={num} delay={i * 0.1}>
            <div className="group relative h-full rounded-[1.5rem] border border-white/10 bg-white/[0.04] p-7 transition-all duration-500 hover:border-[#00B36B]/40 hover:bg-white/[0.07]">
              <span className="text-4xl font-extrabold text-white/10 transition-colors duration-500 group-hover:text-[#00B36B]/30">
                {num}
              </span>
              <div className="mt-5 flex h-11 w-11 items-center justify-center rounded-xl bg-[#00B36B]/15">
                <Icon className="h-5 w-5 text-[#00B36B]" />
              </div>
              <h3 className="mt-5 text-lg font-bold text-white">{title}</h3>
              <p className="mt-2.5 text-sm leading-relaxed text-slate-400">{text}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default MethodSection;
